import { Box, CircularLoader, Icon, IconButton, Typography } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";
import { useState } from "react";
import classNames from "classnames";
import "./UploadedFile.scss";

type UploadedFileProps = {
  name: string;
  error: string | null;
  isLoading: boolean;
  onRemove: () => void;
};

const UploadedFile = ({ name, error, isLoading, onRemove }: UploadedFileProps) => {
  const intl = useIntl();
  const [showError, setShowError] = useState(true);

  const fileClasses = classNames("uploaded-file", {
    "loading": isLoading && !error && !isLoading,
    "error": error && showError,
    "success": name && !isLoading && !error,
  });

  const renderLoading = () => {
    return (
      <Box flexDirection="row" alignItems="center" gap={2}>
        <CircularLoader size={4}/>
        <Typography variant="Body2" text={intl.formatMessage({ id: "project.editForm.uploadLoading", defaultMessage: "Loading..." })} />
      </Box>
    );
  }

  const renderError = () => {
    return (
      <>
        <Box flexDirection="row" alignItems="center" gap={2}>
          <Icon iconId="info" className="icon-warning" size={4} color="ErrorRed" />
          <Typography tag="p" variant="Body2" mt={1} text={intl.formatMessage({ id: "project.editForm.uploadParseFailed", defaultMessage: "Could not read areas from file. Please check the file format." })} />
        </Box>
        <IconButton icon="close" size="Medium" aria-label={intl.formatMessage({ id: "general.close", defaultMessage: "Close" })} onClick={() => {setShowError(false); onRemove()}} />
      </>
    );
  }

  const renderSuccess = () => {
    return (
      <>
        <Box flexDirection="row" alignItems="center" gap={2}>
            <Icon iconId="check-filled" size={4} color="SuccessGreen" />
            <Typography tag="p" variant="Body2" mt={1} text={name} />
        </Box>
        <IconButton icon="trash" size="Medium" aria-label={intl.formatMessage({ id: "general.remove", defaultMessage: "Remove" })} onClick={() => {
            onRemove();
        }} />
      </>
    );
  }

  if(error && !showError) {
    return null;
  }

  return (
    <Box className={fileClasses} br={4} px={3} py={2} my={4} flexDirection="row" alignItems="center" gap={2} justifyContent="space-between">
      {isLoading && renderLoading()}
      {name && !isLoading && !error && renderSuccess()}
      {error && !isLoading && showError && renderError()}
    </Box>
  );
};

export default UploadedFile;